var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-users",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.542,0A5.537,5.537,0,0,0,5.4,11.072a.941.941,0,0,1,.257,0H5.74A5.538,5.538,0,0,0,5.542,0Z",
    transform: "translate(4.958 2.333)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.14,1.627a11.584,11.584,0,0,0-11.842,0A4.605,4.605,0,0,0,0,5.4,4.566,4.566,0,0,0,2.287,9.141a10.779,10.779,0,0,0,5.927,1.645A10.779,10.779,0,0,0,14.14,9.141a4.6,4.6,0,0,0,2.287-3.768A4.594,4.594,0,0,0,14.14,1.627Z",
    transform: "translate(2.287 14.881)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.86,3.831A4.176,4.176,0,0,1,3.208,8.346H3.15a.546.546,0,0,0-.2.023A4.186,4.186,0,0,1,0,7.4,5.339,5.339,0,0,0,1.75,2.967,5.414,5.414,0,0,0,.852.424,4.189,4.189,0,0,1,6.86,3.831Z",
    transform: "translate(16.462 4.733)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M9.333,4.772A3.553,3.553,0,0,1,7.3,7.549a8.235,8.235,0,0,1-4.1.91A4.164,4.164,0,0,0,4.632,5.752,4.6,4.6,0,0,0,2.683,1.809,9.631,9.631,0,0,0,0,.339,9.118,9.118,0,0,1,7.817,1.7,3.545,3.545,0,0,1,9.333,4.772Z",
    transform: "translate(16.322 14.583)",
    fill: "#222227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    transform: "translate(28 28) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.ca8e09664709e7d65b7a8fac28489f9d.svg";
export { ForwardRef as ReactComponent };